export default __webpack_public_path__ + "static/media/black-zoom-out-icon.b978a53a.svg";